import { Nullable, Optional } from "~/types/utility.types";

export const prepareTextAttribute = (
  value: Nullable<Optional<string>>,
  allowEmptyString = false
): Optional<string> => {
  const defaultValue = allowEmptyString ? "" : undefined;
  return value ? String(value).trim() || defaultValue : defaultValue;
};
